import React, { useCallback, useEffect, useState } from 'react';
import { DEVICE_TYPE } from '@amzn/aac-chrome-internal-api';
import { useConsolidatedNavContext } from 'src/providers/ConsolidatedNavContextProvider';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';
import { NavMetricPublisher } from 'src/commons/utils/metrics';
import Remote from './Remote';
import Mount from './Mount';

const loader = () =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  import('AACInterstitialModal/InterstitialModal');

const InterstitialModalHost: React.VFC = () => {
  const {
    interstitialDestinationUrl,
    setInterstitialDestinationUrl,
    interstitialAppName,
    setInterstitialAppName,
  } = useConsolidatedNavContext();
  const { config } = useInternalChromeConfigContext();

  const [loadError, setLoadError] = useState<Error | null>(null);

  const isOpen = !!interstitialDestinationUrl;

  useEffect(() => {
    if (isOpen) {
      NavMetricPublisher.publishCounterMonitor('interstitial_modal_render', 1);
    }
  }, [isOpen]);

  const handleClose = useCallback(() => {
    NavMetricPublisher.publishCounterMonitor('interstitial_modal_close', 1);
    setInterstitialDestinationUrl('');
    setInterstitialAppName('');
  }, [setInterstitialDestinationUrl, setInterstitialAppName]);

  if (loadError) {
    throw loadError;
  }

  return (
    <Remote
      loader={loader}
      timeout={10000}
      afterLoad={() => {
        NavMetricPublisher.publishCounterMonitor(
          'interstitial_modal_load_success',
          1,
        );
      }}
      onError={(e) => {
        NavMetricPublisher.publishCounterMonitor(
          'interstitial_modal_load_error',
          1,
        );
        setLoadError(e);
      }}
      onTimeout={() => {
        NavMetricPublisher.publishCounterMonitor(
          'interstitial_modal_load_timeout',
          1,
        );
        setLoadError(new Error('InterstitialModal remote load timed out'));
      }}
      render={(loaded) => {
        if (!loaded) return <></>;
        const { mount } = loaded;
        return (
          <Mount
            containerId="interstitial-modal"
            mount={mount}
            mountProps={{
              isOpen,
              targetApp: interstitialAppName,
              destinationUrl: interstitialDestinationUrl,
              entityId: config.entityId,
              marketplaceId: config.marketplaceId,
              locale: config.locale,
              isMobile: config.deviceType === DEVICE_TYPE.MOBILE,
              modalElementId: 'AACChromePortal',
              'data-ccx-e2e-id': 'interstitial-modal',
              onClose: handleClose,
            }}
          />
        );
      }}
    />
  );
};

export default InterstitialModalHost;
